import { genColor } from "./tag_utils"

export const prepareOnboardingTeamInvites = (inviteMeta, teamId) => {
    // filters empty emails
    // filters repeated emails
    const invites = Object.keys(inviteMeta).reduce((acc, invite) => {
        const { email, fullName } = inviteMeta[invite]
        return email
            ? {
                ...acc,
                [email]: {
                    teamId,
                    invitedEmail: email,
                    invitedFullName: fullName,
                    role: "Member",
                },
            }: acc
    }, {})

    return invites
}

export const prepareOnboardingTags = (meta, tagTeamId, id) => {
    const tags = Object.keys(meta).reduce((acc, i) => {
        const { name } = meta[i]
        return name
            ? {
                ...acc,
                [name.trim()]: {
                    color: genColor(name),
                    userId: id,
                    name,
                    teamId: tagTeamId,
                },
            } : acc
    }, {})
    return tags
}


// WEBPACK FOOTER //
// ./src/util/ui_saga_utils.js